import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.24 2a.86.86 0 0 1 .86.86v18.29a.86.86 0 0 1-.86.86 9.565 9.565 0 0 1-10-10A9.579 9.579 0 0 1 13.24 2Z",
      fill: "#2159f6",
      opacity: ".32"
    }, null, -1),
    _createElementVNode("path", {
      "data-name": "Vector",
      d: "m20.54 11.541-2.84-2.85a.75.75 0 0 0-1.06 1.06l1.56 1.56H8.63a.75.75 0 0 0 0 1.5h9.57l-1.56 1.562a.754.754 0 0 0 0 1.06.748.748 0 0 0 1.06 0l2.84-2.85a.73.73 0 0 0 0-1.042Z",
      fill: "#2159f6"
    }, null, -1)
  ]))]))
}
export default { render: render }